﻿import { IExecutiveSponsor } from './executive-sponsor';

export interface ICenterSaturation {
    id: number,
    name: string,
    alias: string,

    nkrLiaisonInitials: string,
    nkrLiaisonName: string,

    isParticipant: boolean,
    isMemberCenter: number,
    isRemoteDonationCenter: number,
    allInAddendumSigned: number,
    allInBestGuess: boolean,
    partnerCenter: number,

    screeningVirtualCrossMatchUser: number,
    donorProtectionAddendumSigned: number,

    voucherProgramActive: number,
    voucherProgramUtilization: number,
    totalStandardVouchers: number,
    totalFamilyVouchers: number,
    totalVouchers: number,
    familyVouchersAndNDD: number,
    

    donorShieldDirectUser: number,
    donorShieldDirectFullyUtilized: number,
    donorShieldDirectLiverParticipant: number,
    dsdUtilization: number,
    dsdCaseCount: number,
    dsdL90CaseCount: number,

    dashActive: number,
    dashFullyUtilized: number,
    dashUtilization: number,
    dashCount: number,

    liverDashActive: number,

    pwlActive: number,
    pwlFullyUtilized: number,
    pwlCount: number,
    pwlUtilization: number,

    automatedDonorFollowUpActive: number,
    automatedDonorFollowUpFullyUtilized: number,
    automatedDonorFollowUpUtilization: number,
    followupCount: number,

    micrositesActive: number,
    micrositesFullyUtilized: number,
    micrositeCount: number,
    micrositeActiveStarterSiteCount: number,
    micrositeActiveCustomSiteCount: number,
    micrositesLdtxpL12: number,

    isAcceptingPatientReferralsForMicrosites: number,
    completedMoreThan0PatientTrainingSessions: number,
    completedMoreThan2PatientTrainingSessions: number,
    acceptingDonorReferrals: number,
    acceptingPatientReferrals: number,
    acceptingKflPatientReferrals: number,

    optInAutomatedSerologies: number,
    includedInCenterListingService: number,

    donorReferralCount: number,
    donorReferralConversionRate: number,
    patientsWithLivingDonorReferralCount: number,
    patientsDesiringMicrositeReferralCount: number,
    patientsDesiringKflReferralCount: number,
    patientsTotalCount: number,

    automatedCollectionsAndClearing: number,
    automatedCollectionsAndClearingInvoiceCount: number,
    shbEligibleSwaps: number,
    invoiceCount3to9Months: number,
    shbEligibleCount3to9Months: number,
    shbUtilized: number,
    shbFullyUtilized: number,
    isExpertSystem: number
    expertSystemFullyUtilized: number,
    donorReferralCompleteCount: number,
    donorReferralComplete3gCount: number,

    ubpInvTrigCount: number,

    automatedCollectionsAndClearingTotalCharges: number,
    streamlinedBillingService: number,
    utilizing3GTyping: boolean,

    billable: number,
    donorCareNetworkCenter: number,
    offerDonorConnect: number,

    xpLast12Months: number,

    executiveSponsor: IExecutiveSponsor,
    livingDonorCount: number,
    livingDonorCountQuarterly: number,
    totalDonors: number,
    totalProtectedDonors: number,
    totalDonorsWithDsd: number,
    txpCount: number,
    txpCountAllTime: number
    txpL90Count: number,
    nddCount: number,
    waitListCount: number,
    hrTxpCountL12: number,
    lowExpletTxpCountL12M: number,

    exportableRecipientCount: number,
    exportableRecipient3GTypingCount: number,
    txpRecipient3GTypingCountL6M: number,
    txpRecipient3GTypingCount: number,
    txpCountNonAdpChipL6M: number,

    kidneyForLifeActive: number,
    kidneyForLifeFullyUtilized: number,
    kidneyForLifeUtilization: number,
    kidneyForLifeUtilizationProduct: number,
    kidneyForLifeSuccess: number,

    directStreamlinedSerologyCount: number,

    homeBloodDrawCount: number,
    homeBloodDrawCountTarget: number,

    vem: number,

    vemRefCount: number,
    vemOptedOutCount: number,
    vemWantsMoreInfoCount: number,
    vemOptedInCount: number,
    vemNoChoiceCount: number,

    notes: string,
    category: string,

    saturationTotal: number,
    saturationAnnualGoal: number,
    saturationVariance: number
}
